import messages from './cmsEditorForm.json' with { type: 'json' };

export const cmsEditorFormFi: Readonly<typeof messages> = messages;
